import { SectionTitle } from '@shared/components/SectionTitle';
import { BorderWrapper } from '@styles/CommonStyles';
import { AvoidPageBreakInsideWrapper } from '@styles/StyledDiv';


interface IWarningMessage {
  messages: string[];
}

export const WarningMessage = ({ messages }: IWarningMessage) => {
  return (
    <AvoidPageBreakInsideWrapper>
      <SectionTitle title="Warning Messages" fontWeight={600} />

      <BorderWrapper padding='10px' >
        {messages ? messages.map((msg, index) => <div key={index}>{msg}</div>) : 'No Records Found'}
      </BorderWrapper>
    </AvoidPageBreakInsideWrapper>
  );
};
